import request from '../utility/request'

export const readMoreClick = (button: HTMLButtonElement): void => {
  button.addEventListener('click', () => {
    const pageId = window.OP_METRICS.id
    const lang = window.OP_METRICS.locale

    if (pageId != null && lang != null) {
      request(
        'GET',
        `/click_more_click_counts?id=${pageId}&locale=${lang}`,
        undefined,
        undefined,
        undefined
      )
    }
    button.style.display = 'none'
  })
}

export const readMoreViewed = (button: HTMLButtonElement): void => {
  const io = new IntersectionObserver(
    (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
      Array.prototype.forEach.call(
        entries,
        (entry: IntersectionObserverEntry) => {
          if (entry.isIntersecting) {
            const pageId = window.OP_METRICS.id
            const lang = window.OP_METRICS.locale

            if (pageId != null && lang != null) {
              request(
                'GET',
                `/click_more_view_counts?id=${pageId}&locale=${lang}`,
                undefined,
                undefined,
                undefined
              )
            }

            observer.disconnect()
          }
        }
      )
    }
  )
  io.observe(button)
}
